
export const dealerRegistration = {
  hero: {
    badge: 'PARTNER WERDEN',
    title: 'Werden Sie offizieller Dutch Fires Händler',
    subtitle: 'Erhalten Sie Zugang zu hochwertigen elektrischen Kaminen für den professionellen Markt.'
  },
  benefits: {
    title: 'Ihre Vorteile als Dutch Fires Händler',
    benefit1: {
      icon: 'ri-price-tag-3-line',
      title: 'Hohe Händlermargen',
      description: 'Attraktive Einkaufskonditionen für Fachhändler und Projektpartner.'
    },
    benefit2: {
      icon: 'ri-shield-check-line',
      title: 'Premium Produktlinie',
      description: 'Exklusive elektrische Kamine mit Fokus auf Design, Qualität und Zuverlässigkeit.'
    },
    benefit3: {
      icon: 'ri-customer-service-2-line',
      title: 'Marketing & Support',
      description: 'Produktdaten, Visuals und technische Unterstützung für Ihr Verkaufsteam.'
    },
    benefit4: {
      icon: 'ri-truck-line',
      title: 'Europaweite Lieferung',
      description: 'Zuverlässige Logistik für Projekte und Wiederverkäufer in ganz Europa.'
    }
  },
  requirements: {
    title: 'Voraussetzungen für eine Partnerschaft',
    subtitle: 'Dutch Fires arbeitet ausschließlich mit Geschäftskunden zusammen.',
    req1: 'Gewerbliche Registrierung (z. B. Handelsregister / KvK)',
    req2: 'Aktivität im Bereich Interieur, Bau, Haustechnik oder Handel',
    req3: 'Professioneller Showroom oder Online-Präsenz',
    req4: 'Engagement für Qualität und Kundenservice'
  },
  form: {
    title: 'Händler-Anfrage stellen',
    subtitle: 'Füllen Sie das Formular aus – wir melden uns kurzfristig bei Ihnen.',
    companyName: 'Firmenname',
    companyNamePlaceholder: 'Ihr Firmenname',
    contactPerson: 'Ansprechpartner',
    contactPersonPlaceholder: 'Vor- und Nachname',
    email: 'E-Mail-Adresse',
    emailPlaceholder: 'ihre.email@firma.de',
    phone: 'Telefonnummer',
    phonePlaceholder: '+49 30 123 4567',
    website: 'Website (optional)',
    websitePlaceholder: 'www.ihrefirma.de',
    country: 'Land',
    countryPlaceholder: 'Wählen Sie Ihr Land',
    industry: 'Branche',
    industryPlaceholder: 'Wählen Sie Ihre Branche',
    message: 'Nachricht / kurze Vorstellung Ihres Unternehmens',
    messagePlaceholder: 'Erzählen Sie uns über Ihr Unternehmen und warum Sie Dutch Fires Händler werden möchten...',
    submit: 'Anfrage senden',
    submitting: 'Wird gesendet...',
    success: 'Vielen Dank für Ihre Anfrage! Wir melden uns kurzfristig bei Ihnen.',
    error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.',
    required: 'Dieses Feld ist erforderlich',
    invalidEmail: 'Ungültige E-Mail-Adresse',
    industries: {
      fireplace: 'Kamingeschäft',
      interior: 'Interieurgeschäft',
      construction: 'Bauunternehmen',
      ecommerce: 'E-Commerce',
      other: 'Andere'
    }
  },
  process: {
    title: 'So werden Sie Dutch Fires Händler',
    step1: {
      title: 'Anfrage senden',
      description: 'Übermitteln Sie Ihre Händleranfrage über das Formular.'
    },
    step2: {
      title: 'Prüfung',
      description: 'Wir prüfen Ihre Unternehmensdaten und Marktposition.'
    },
    step3: {
      title: 'Kontaktaufnahme',
      description: 'Unser Team meldet sich persönlich bei Ihnen.'
    },
    step4: {
      title: 'Partnerschaft starten',
      description: 'Nach Freigabe erhalten Sie Zugang zu Konditionen und Produkten.'
    }
  },
  cta: {
    title: 'Interesse an einer Zusammenarbeit?',
    email: 'info@dutchfires.de'
  }
};
